module.exports = __webpack_public_path__ + "d9749793327142d87c72f52bf708b361.svg";